import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import { Table, RowsPerPageSelect } from "../../../components/Table";
import Card from "../../../components/Card/Card";
import { useMutation, useQuery } from "@apollo/client";

import { amountFormat } from "../../../utils/amountFormat";
import { MdDelete, MdFileUpload } from "react-icons/md";
import Modal from "../../../components/Modal/Modal";
import {
  GET_MERCHANT_DISPUTES,
  UPLOAD_DISPUTE_DOCUMENT,
} from "../../../Qurries";
import { AiOutlineEye, AiOutlineLoading3Quarters } from "react-icons/ai";
import IframeModal from "../../../components/Modal/IframeModal";
import { getStartAndEndOfMonth } from "../../../utils/getStartDateAndEndDate";
import { HiMiniXMark } from "react-icons/hi2";
import Select from "react-select";
import { CustomDropdownIndicator } from "../Settlement/Settlement";
import TransactionDateFilter, {
  formatDate,
} from "../Transaction/components/TransactionDateFilter";
import { endOfDay, startOfDay } from "date-fns";
import { toast } from "react-toastify";
import { IoSearchOutline } from "react-icons/io5";
import { usePaymentUrlFilters } from "../../../hooks/usePaymentUrlFilters";
import { parseDateParam } from "../../../utils/paymentUrlFilters";
import {
  CASHFREE_DISPUTE_DOC_TYPES,
  isCashfreeGateway,
} from "../../../utils/cashfreeDisputeDocTypes";

const ViewDocs = ({
  item,
  setUrl,
  setIsModalOpen,
}: {
  item: any;
  setUrl: any;
  setIsModalOpen: any;
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Modal
        title={"View Files"}
        className="min-w-[4rem]"
        hasChanged={true}
        children={
          <div>
            <Table
              minHeight="h-auto"
              copyContent={false}
              copyRight={false}
              boxPadding={" p-0"}
              data={[
                ["Name", "Description", "Action"],
                ...item.documents.map((doc: any, index: any) => [
                  <div> {doc.name}</div>,
                  <div> {doc.name}</div>,
                  <div>
                    {
                      <AiOutlineEye
                        className="text-black text-lg cursor-pointer"
                        onClick={() => {
                          setUrl(doc.file_url);
                          setIsModalOpen(true);
                        }}
                      />
                    }
                  </div>,
                ]),
              ]}
            />
          </div>
        }
        open={showModal}
        setOpen={setShowModal}
      />
      <AiOutlineEye
        className="text-black text-lg cursor-pointer"
        onClick={() => setShowModal(true)}
      />
    </>
  );
};

// const UploadDocs = ({ id }: { id: string }) => {
//   const [showModal, setShowModal] = useState(false);
//   const [showUpload, setShowUpload] = useState(false);
//   const [files, setFiles] = useState<any>([]);
//   const boxRef = useRef<HTMLDivElement | null>(null);
//   const [uploadDisputDocs, { loading }] = useMutation(UPLOAD_DISPUTE_DOCUMENT);
//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (boxRef.current && !boxRef.current.contains(event.target as Node)) {
//         setShowModal(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);
//   const handleFileChange = (e: any) => {
//     const files = e.target.files;
//     if (!files) return;
//     const fileArray = Array.from(files);

//     const readers = fileArray.map((file: any) => {
//       return new Promise<{ name: string; file: string; extension: string }>(
//         (resolve, reject) => {
//           const reader = new FileReader();
//           reader.onload = () => {
//             resolve({
//               name: file.name,
//               extension: file.type,
//               file: reader.result as string,
//             });
//           };
//           reader.onerror = reject;
//           reader.readAsDataURL(file);
//         }
//       );
//     });

//     Promise.all(readers)
//       .then((results) => {
//         setFiles((prevFiles: any) => [...prevFiles, ...results].slice(0, 5));
//       })
//       .catch((error) => {
//         console.error("Error reading files:", error);
//       });
//   };

//   const handleFileDelete = (index: number) => {
//     setFiles((prevFiles: any) =>
//       prevFiles.filter((_: any, i: number) => i !== index)
//     );
//   };

//   return (
//     <>
//       <Modal
//         title={"Upload Files"}
//         children={
//           <div className="space-y-3">
//             {files.map((file: any, index: number) => (
//               <div
//                 key={file?.name}
//                 className="w-full relative  col-span-2   md:col-span-1 first:col-span-2 p-2 border-2 rounded-md last:col-span-2 border-gray-400  border-dashed flex flex-col items-center justify-center"
//               >
//                 <>
//                   <div className="flex py-2 px-4 gap-x-2 max-w-[11rem] w-full  text-[#505E8E] items-center text-xs bg-[#EAECF4] rounded-md">
//                     <div
//                       key={index}
//                       className="flex justify-between w-full gap-x-2 items-center"
//                     >
//                       <VscFilePdf className="shrink-0" />
//                       <p className="text-xs max-w-[9rem] truncate">
//                         {file.name}
//                       </p>
//                       <button onClick={() => handleFileDelete(index)}>
//                         <RxCross1 />
//                       </button>
//                     </div>
//                   </div>
//                 </>
//               </div>
//             ))}
//             <div className="w-full relative  col-span-2   md:col-span-1 first:col-span-2 pt-2 border-2 rounded-md last:col-span-2 border-gray-400  border-dashed flex flex-col items-center justify-center">
//               <h2 className="overflow-hidden flex gap-x-2 absolute left-10 -top-[9px] px-1 bg-[#F6F8FA] text-xs font-normal">
//                 <span className="text-[#A9B2CF] sm:block hidden">(</span>
//                 <div className=" text-[#A9B2CF] xl:max-w-lg max-w-[10rem] sm:block hidden truncate">
//                   Chargeback Proof
//                 </div>
//                 <span className="text-[#A9B2CF] sm:block hidden">)</span>
//               </h2>
//               <label htmlFor={"uploadDoc"}>
//                 <img
//                   src={uploadLogo}
//                   alt="uploadImage"
//                   className={`cursor-pointer block m-auto w-full h-8`}
//                 />
//               </label>
//               <input
//                 type="file"
//                 id="uploadDoc"
//                 accept="image/*,application/pdf"
//                 multiple
//                 onChange={handleFileChange}
//                 disabled={files.length >= 5}
//                 className="hidden"
//               />
//               <p className={"text-[10px]"}>
//                 <span className=" text-[#00AA11]">Upload</span> file
//                 <span className="text-[#B8C0CD]"> (.pdf)</span>
//               </p>
//             </div>
//             <button
//               disabled={!files.length || loading}
//               onClick={ async ()  => {
//                 console.log(id, "id")
//                const response = await uploadDisputDocs({
//                   variables: {
//                     collect_id: id,
//                     files: files,
//                     action: "accept",
//                   },
//                   refetchQueries: [
//                     {
//                       query: GET_MERCHANT_DISPUTES,
//                       variables: {
//                         page: 1,
//                         limit: 100,
//                       },
//                     },
//                   ],
//                 });
//                 if (response.data.handleAndUploadMerchantDisputeDocs.success) {
//                   toast.success(response.data.handleAndUploadMerchantDisputeDocs.message);
//                   setShowUpload(false);
//                 }
//               }}
//               className="bg-[#6687FF] disabled:bg-gray-300 text-white rounded-md px-4 py-1.5 w-full"
//             >
//               {loading ? "Uploading..." : "Upload Files"}
//             </button>
//           </div>
//         }
//         open={showUpload}
//         setOpen={setShowUpload}
//         closeAction={() => {
//           setFiles([]);
//         }}
//       />
//       <div className="relative text-center w-10">
//         {showModal && (
//           <div
//             ref={boxRef}
//             className="absolute bottom-0 rounded-xl w-40 overflow-hidden right-10 z-[99999999]"
//           >
//             <button className="px-4 py-2 bg-gray-200 w-full text-black">
//               Action
//             </button>
//             <button
//               onClick={() => {
//                 setShowUpload(true);
//                 setShowModal(false);
//               }}
//               className="px-4 py-2 border-t border-gray-400 bg-gray-200 w-full text-black"
//             >
//               Upload Docs
//             </button>
//           </div>
//         )}
//         <HiOutlineDotsVertical
//           className="text-xl cursor-pointer"
//           onClick={() => setShowModal(!showModal)}
//         />
//       </div>
//     </>
//   );
// };

const UploadDocs = memo(({ id, item }: { id: string; item: any }) => {
  const [showModal, setShowModal] = useState(false);
  const [files, setFiles] = useState<any[]>([]);
  const [collectId, setcollectId] = useState("");
  const requiresCashfreeDocType = isCashfreeGateway(item?.gateway);

  const convertFileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const handleFileChange = async (event: any) => {
    const selectedFiles = Array.from(event.target.files);
    setcollectId(item.collect_id);
    if (selectedFiles.length > 5) {
      return toast.warn("Select only 5 files at once");
    }

    const validFiles = (
      await Promise.all(
        selectedFiles.map(async (file: any) => {
          if (file.size <= 5 * 1024 * 1024) {
            const base64 = await convertFileToBase64(file);
            return {
              file: base64,
              name: file.name,
              description: "",
              doc_type: "",
              preview: URL.createObjectURL(file),
            };
          } else {
            toast.warn(
              `${file.name} exceeds the 5MB limit and will not be added.`
            );
            return null;
          }
        })
      )
    ).filter(Boolean);

    if (validFiles.length > 0) {
      setFiles((prevFiles) => [...prevFiles, ...validFiles].slice(0, 5));
    }
  };

  const handleFileDelete = (index: number) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleInputChange = (
    index: number,
    field: "name" | "description" | "doc_type",
    value: string
  ): void => {
    setFiles((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles[index][field] = value;
      return updatedFiles;
    });
  };

  // const [uploadDisputDocs, { loading }] = useMutation(UPLOAD_DISPUTE_DOCUMENT);
  const [handleUpload, { loading }] = useMutation(
    UPLOAD_DISPUTE_DOCUMENT,
    {
      refetchQueries: [GET_MERCHANT_DISPUTES],
    }
  );

  const prepareFiles = (files: any) => {
    return files.map((file: any) => {
      const extension = file.name.split(".").pop().toLowerCase();

      return {
        ...file,
        extension,
        doc_type: file.doc_type || null,
      };
    });
  };

  const allCashfreeDocTypesSelected =
    !requiresCashfreeDocType ||
    (files.length > 0 && files.every((file) => Boolean(file.doc_type)));

  const handleSubmit = async () => {
    if (requiresCashfreeDocType && !allCashfreeDocTypesSelected) {
      toast.warn("Select a Cashfree evidence type for each file");
      return;
    }
    try {
      const filesToSend = Array.isArray(files)
        ? prepareFiles(files)
        : prepareFiles([files]);
      const response = await handleUpload({
        variables: {
          collect_id: collectId,
          action: "accept",
          files: filesToSend,
          reason: null,
        },
      });

      if (response.data.handleAndUploadMerchantDisputeDocs.success) {
        toast.success(response.data.handleAndUploadMerchantDisputeDocs.message);
        setShowModal(false);
      }
      // console.log("Response:", response.data.handleAndUploadDisputDocs);
    } catch (err) {
      console.error("Mutation error:", err);
    }
  };

  return (
    <>
      <Modal
        title={"Upload Files"}
        className={
          requiresCashfreeDocType ? "min-w-[52rem] max-w-[95vw]" : "min-w-[3rem]"
        }
        hasChanged={true}
        children={
          <div>
            <input
              type="file"
              accept="image/*,application/pdf"
              onChange={handleFileChange}
              className="block w-full text-sm text-grey-500
                  file:mr-4 file:py-2 file:px-4
                  file:rounded-full file:border-0
                  file:text-sm file:font-semibold
                  file:bg-violet-50 file:text-grey-700
                  hover:file:bg-violet-100 file:disabled:bg-slate-200 file:disabled:text-gray-400 file:disabled:cursor-not-allowed file:cursor-pointer"
            />
            {requiresCashfreeDocType && (
              <p className="mt-2 text-xs text-gray-500">
                Cashfree requires an evidence type per file (e.g. Delivery/Service
                Proof). Select the type that matches Cashfree&apos;s dispute
                requirements.
              </p>
            )}
            <>
              {files.length > 0 ? (
                <Table
                  minHeight="h-auto"
                  copyContent={false}
                  copyRight={false}
                  data={[
                    requiresCashfreeDocType
                      ? ["Name", "Evidence type", "Note", "Action"]
                      : ["Name", "Description", "Action"],
                    ...files.map((file: any, index: number) => [
                      <input
                        key={`name-${index}`}
                        className="rounded-md max-w-md w-full px-4 py-1 focus:outline-none border border-gray-400"
                        type="text"
                        placeholder="Name"
                        onChange={(e) =>
                          handleInputChange(index, "name", e.target.value)
                        }
                        defaultValue={file.name}
                      />,
                      requiresCashfreeDocType ? (
                        <div
                          key={`doc-type-wrap-${index}`}
                          className="min-w-[18rem] w-72 shrink-0"
                        >
                          <select
                            key={`doc-type-${index}`}
                            className="rounded-md w-full min-w-[18rem] px-2 py-1 focus:outline-none border border-gray-400 text-sm"
                            value={file.doc_type || ""}
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "doc_type",
                                e.target.value,
                              )
                            }
                          >
                            <option value="">Select evidence type</option>
                            {CASHFREE_DISPUTE_DOC_TYPES.map((docType) => (
                              <option key={docType} value={docType}>
                                {docType}
                              </option>
                            ))}
                          </select>
                        </div>
                      ) : (
                        <input
                          key={`desc-${index}`}
                          className="rounded-md max-w-md w-full px-4 py-1 focus:outline-none border border-gray-400"
                          type="text"
                          placeholder="Description"
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "description",
                              e.target.value
                            )
                          }
                        />
                      ),
                      requiresCashfreeDocType ? (
                        <input
                          key={`note-${index}`}
                          className="rounded-md max-w-md w-full px-4 py-1 focus:outline-none border border-gray-400"
                          type="text"
                          placeholder="Note (optional)"
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "description",
                              e.target.value
                            )
                          }
                        />
                      ) : null,
                      <button
                        key={`delete-${index}`}
                        onClick={() => handleFileDelete(index)}
                      >
                        <MdDelete />
                      </button>,
                    ].filter(Boolean)),
                  ]}
                />
              ) : (
                <Table
                  minHeight="h-auto"
                  copyContent={false}
                  copyRight={false}
                  data={[
                    requiresCashfreeDocType
                      ? ["Name", "Evidence type", "Note", "Action"]
                      : ["Name", "Description", "Action"],
                    ...Array.from({ length: 1 }).map((_, index) => [
                      <div
                        key={`skeleton-name-${index}`}
                        className="h-8 w-full max-w-md animate-pulse bg-gray-200 rounded-md"
                      />,
                      <div
                        key={`skeleton-desc-${index}`}
                        className="h-8 w-full max-w-md animate-pulse bg-gray-200 rounded-md"
                      />,
                      <div
                        key={`skeleton-action-${index}`}
                        className="h-8 w-8 animate-pulse bg-gray-200 rounded-full"
                      />,
                    ]),
                  ]}
                />
              )}
              {files.length > 0 && (
                <button
                  className="mt-4 px-4 py-1 bg-gray-600 text-white rounded-md hover:bg-gray-700 float-right disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={handleSubmit}
                  disabled={loading || !allCashfreeDocTypesSelected}
                >
                  {loading ? "Uploading..." : "Submit"}
                </button>
              )}
              {/* {item.documents && item.documents.length > 0 && (
                item.documents.map((doc:any, index:any) => (
                  <div key={index}>
                    <a href={doc.file_url} target="_blank" rel="noopener noreferrer">
                      {doc.name || `Document ${index + 1}`}
                    </a>
                  </div>
                ))
              )} */}
            </>
          </div>
        }
        open={showModal}
        setOpen={setShowModal}
      />
      <div className=" text-center w-10">
        <MdFileUpload
          className="text-xl cursor-pointer"
          onClick={() => setShowModal(true)}
        />
      </div>
    </>
  );
});

interface RefetchParams {
  Page?:number|null;
  limit?:number|null;
  start_date?: string | null;
  end_date?: string | null;
  status?: string;
  school_id?: string;
  collect_id?: string;
  custom_id?: string;
  dispute_id?: string;
}

function Disputes() {
  const { get, getNumber, getBoolean, updateParams } = usePaymentUrlFilters();
  const skipUrlSyncRef = useRef(true);
  const [page, setPage] = useState(() => getNumber("page", 1));

  const [url, setUrl] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [searchText, setSearchText] = useState(() => get("search"));
  const [searchFilter, setSearchFilter] = useState<any>(() =>
    get("search_filter"),
  );
  const [refetchLoading, setRefetchLoading] = useState(false);
  const [dateRange, setDateRange] = useState(() => get("date_range"));
  const [isDateRangeIsSelected, setIsDateRangeIsSelected] = useState(() =>
    getBoolean("custom_date"),
  );
  const [status, setStatus] = useState(() => get("status"));
  // const [selectSchool,] = useState<any>("");
  const [schoolId, ] = useState<any>(get("school_id") || null);
  const { startDate, endDate } = getStartAndEndOfMonth();
  const urlStartDate = parseDateParam(get("start_date"));
  const urlEndDate = parseDateParam(get("end_date"));
  const [itemsPerRow, setItemsPerRow] = useState<{ name: number }>({
    name: getNumber("limit", 10),
  });
  // const [filters, setFilters] = useState<any>({
  //   paymentMode: {
  //     credit_card: false,
  //     credit_card_emi: false,
  //     upi: false,
  //     wallet: false,
  //     pay_later: false,
  //     cardless_emi: false,
  //     net_banking: false,
  //     debit_card_emi: false,
  //     debit_card: false,
  //     na: false,
  //   },
  // });
  const [selectedRange, setSelectedRange] = useState({
    startDate: urlStartDate || new Date(),
    endDate: urlEndDate || new Date(),
    key: "selection",
  });

  const [dueAmounts, setDueAmounts] = useState({
    todayDueAmount: 0,
    tomorrowDueAmount: 0,
  });
  const {
    data: disputeData,
    refetch,
  } = useQuery(GET_MERCHANT_DISPUTES, {
    onCompleted(data) {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      const todayString = today.toISOString().split("T")[0];
      const tomorrowString = tomorrow.toISOString().split("T")[0];

      let todayDue = 0;
      let tomorrowDue = 0;

      data.getMerchantDisputes?.disputes.forEach((transaction: any) => {
        const dueDate = new Date(transaction.dispute_respond_by_date)
          .toISOString()
          .split("T")[0];

        if (dueDate === todayString) {
          todayDue += transaction.dispute_amount;
        } else if (dueDate === tomorrowString) {
          tomorrowDue += transaction.dispute_amount;
        }
      });

      setDueAmounts({
        todayDueAmount: todayDue,
        tomorrowDueAmount: tomorrowDue,
      });
    },
    variables: {
      page:page,
      limit:itemsPerRow.name,
      // startDate: startDate, 
      // endDate: endDate
    },
  });    
  const refetchDataFetch = useCallback(async ({
    Page,
    limit,
    start_date,
    end_date,
    status,
    school_id,
    collect_id,
    custom_id,
    dispute_id,
  }: RefetchParams) => {
    setRefetchLoading(true);
    try {
      const res = await refetch({
        page:Page,
        limit:limit,
        startDate: start_date,
        endDate: end_date,
        dispute_status: status,
        school_id,
        collect_id,
        custom_id,
        dispute_id,
      });
      if (res) {
        setRefetchLoading(false);
      }
    } catch (error) {
      setRefetchLoading(false);
    }
  }, [refetch]);
  
  useEffect(() => {
    skipUrlSyncRef.current = false;
  }, []);

  useEffect(() => {
    if (skipUrlSyncRef.current) return;

    updateParams({
      page: page > 1 ? page : null,
      limit: itemsPerRow.name !== 10 ? itemsPerRow.name : null,
      search: searchText || null,
      search_filter: searchFilter || null,
      status: status || null,
      start_date: isDateRangeIsSelected
        ? formatDate(selectedRange.startDate)
        : null,
      end_date: isDateRangeIsSelected
        ? formatDate(selectedRange.endDate)
        : null,
      custom_date: isDateRangeIsSelected ? true : null,
      date_range: dateRange || null,
      school_id: schoolId || null,
    });
  }, [
    page,
    itemsPerRow.name,
    searchText,
    searchFilter,
    status,
    isDateRangeIsSelected,
    selectedRange.startDate,
    selectedRange.endDate,
    dateRange,
    schoolId,
    updateParams,
  ]);

  useEffect(() => {
    if (searchParamsHasFilters()) {
      refetchDataFetch({
        Page: page,
        limit: itemsPerRow.name,
        start_date: isDateRangeIsSelected
          ? formatDate(selectedRange.startDate)
          : null,
        end_date: isDateRangeIsSelected
          ? formatDate(selectedRange.endDate)
          : null,
        status: status,
        school_id: schoolId,
        collect_id: searchFilter === "collect_id" ? searchText : "",
        custom_id: searchFilter === "custom_order_id" ? searchText : "",
        dispute_id: searchFilter === "dispute_id" ? searchText : "",
      });
    }

    function searchParamsHasFilters() {
      return Boolean(
        get("search") ||
          get("search_filter") ||
          get("status") ||
          getBoolean("custom_date") ||
          get("date_range"),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   refetchDataFetch({
  //     start_date: isDateRangeIsSelected
  //       ? formatDate(selectedRange.startDate)
  //       : null,
  //     end_date: isDateRangeIsSelected
  //       ? formatDate(selectedRange.endDate)
  //       : null,
  //     status: status,
  //     school_id: schoolId,
  //   });
  // }, [page, limit, schoolId, status,isDateRangeIsSelected,refetchDataFetch,selectedRange.endDate, selectedRange.startDate]);

  return (
    <div>
      <IframeModal url={url} isOpen={isModalOpen} onClose={setIsModalOpen} />
      <div className="grid grid-cols-3 gap-5 mb-4">
        <Card
          amount={amountFormat(dueAmounts.todayDueAmount)}
          date={"Due Today"}
          description={"Amount"}
        />
        <Card
          amount={amountFormat(dueAmounts.tomorrowDueAmount)}
          date={"Due Tommorrow"}
          description={"Amount"}
        />
        <Card
          amount={0}
          date={"Insufficient Evidence"}
          description={"Amount"}
        />
      </div>
      <Table
        heading="Disputes"
        exportBtn={true}
        pagination={true}
        searchBox={
          <div className="w-full">
            <div className="flex xl:!flex-row flex-col justify-between gap-2  w-full xl:items-center items-start mb-2">
              <div className="bg-[#EEF1F6] py-3 items-center flex  px-3 xl:max-w-md max-w-[34rem] w-full rounded-lg">
                <input
                  className="text-xs pr-2 bg-transparent focus:outline-none w-full placeholder:font-normal"
                  type="text"
                  value={searchText}
                  placeholder=" Search(Order ID...)"
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                />
                {searchFilter !== "" && searchText.length > 3 && (
                  <HiMiniXMark
                    onClick={async () => {
                      setSearchFilter("");
                      setSearchText("");
                      refetchDataFetch({});
                    }}
                    className="text-[#1E1B59] cursor-pointer text-md mr-2 shrink-0"
                  />
                )}
                <Select
                  className="border-l-2 border-gray-400"
                  options={[
                    {
                      label: "By Order ID",
                      value: "custom_order_id",
                    },
                    { label: "By Edviron Order ID", value: "collect_id" },
                    { label: "By Dispute ID", value: "dispute_id" },
                  ]}
                  isSearchable={false}
                  components={{
                    DropdownIndicator: CustomDropdownIndicator,
                    IndicatorSeparator: () => null,
                  }}
                  onChange={(e: any) => {
                    setSearchFilter(e.value.toLowerCase());
                    setPage(1);
                  }}
                  placeholder={
                    <div className="text-[#1E1B59] -mt-1 capitalize text-[10px]">
                      {searchFilter === ""
                        ? "filter by"
                        : searchFilter
                            .toString()
                            .toLowerCase()
                            .replaceAll("_", " ") === "order id"
                        ? "Edviron Order ID"
                        : searchFilter
                            .toString()
                            .toLowerCase()
                            .replaceAll("_", " ")}
                    </div>
                  }
                  value={searchFilter}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      backgroundColor: "transparent",
                      height: "20px",
                      border: "none",
                      boxShadow: "none",
                      cursor: "pointer",
                      minHeight: "10px",
                      padding: "0px",
                    }),
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "20px",
                      width: "8rem",
                      padding: "0 8px",
                    }),
                    input: (provided) => ({
                      ...provided,
                      margin: "0",
                      padding: "0",
                    }),
                    placeholder: (provided) => ({
                      ...provided,
                      margin: "0",
                      padding: "0",
                      lineHeight: "20px",
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      lineHeight: "20px",
                    }),
                    indicatorsContainer: (provided) => ({
                      ...provided,
                      height: "20px",
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: "10px",
                      cursor: "pointer",
                    }),
                  }}
                />

                <div className="w-10 z-50 shrink-0 flex justify-center items-center">
                  {searchText.length > 3 && refetchLoading ? (
                    <AiOutlineLoading3Quarters className="text-xs animate-spin" />
                  ) : (
                    <IoSearchOutline
                      onClick={() => {
                        if (searchText.length > 3 && searchFilter !== "") {
                          setPage(1);
                          refetchDataFetch({
                            Page:1,
                            limit:itemsPerRow.name,
                            custom_id:
                              searchFilter === "custom_order_id"
                                ? searchText
                                : "",
                            collect_id:
                              searchFilter === "collect_id" ? searchText : "",
                            dispute_id:
                              searchFilter === "dispute_id" ? searchText : "",
                            start_date: isDateRangeIsSelected
                              ? formatDate(selectedRange.startDate)
                              : null,
                            end_date: isDateRangeIsSelected
                              ? formatDate(selectedRange.endDate)
                              : null,
                            status: status,
                            school_id: schoolId === "" ? null : schoolId,
                          });
                        }
                      }}
                      className=" cursor-pointer text-edvion_black text-opacity-50 text-md "
                    />
                  )}
                </div>
              </div>

              <div className="flex justify-end items-center flex-1 w-full max-w-[34rem]">
                <TransactionDateFilter
                  setType={setDateRange}
                  type={dateRange}
                  refetch={() => {
                    setPage(1);
                    refetchDataFetch({
                      Page:1,
                      limit:itemsPerRow.name,
                      custom_id:
                        searchFilter === "custom_order_id"
                          ? searchText
                          : "",
                      collect_id:
                        searchFilter === "collect_id" ? searchText : "",
                      dispute_id:
                        searchFilter === "dispute_id" ? searchText : "",
                      start_date: isDateRangeIsSelected
                        ? formatDate(selectedRange.startDate)
                        : null,
                      end_date: isDateRangeIsSelected
                        ? formatDate(selectedRange.endDate)
                        : null,
                      status: status,
                      school_id: schoolId === "" ? null : schoolId,
                    });
                  }}
                  selectedRange={selectedRange}
                  setSelectedRange={setSelectedRange}
                  setIsDateRangeIsSelected={setIsDateRangeIsSelected}
                  //status={status}
                  //schoolId={schoolId}
                />
                <div className="w-full">
                  <Select
                    className="font-normal m-0 p-2 capitalize"
                    options={[
                      { label: "DISPUTE_CREATED", value: "DISPUTE_CREATED" },
                      {
                        label: "REQUEST_INITIATED",
                        value: "REQUEST_INITIATED",
                      },
                      { label: "DISPUTE_CLOSED", value: "DISPUTE_CLOSED" },
                      {
                        label: "DISPUTE_UNDER_REVIEW",
                        value: "DISPUTE_UNDER_REVIEW",
                      },
                      {
                        label: "CHARGEBACK_MERCHANT_WON",
                        value: "CHARGEBACK_MERCHANT_WON",
                      },
                      {
                        label: "PRE_ARBITRATION_CREATED",
                        value: "PRE_ARBITRATION_CREATED",
                      },
                      {
                        label: "CHARGEBACK_MERCHANT_WON",
                        value: "CHARGEBACK_MERCHANT_WON",
                      },
                    ].map((status: any) => {
                      return {
                        label: status.label?.toLowerCase().replaceAll("_", " "),
                        value: status.value,
                      };
                    })}
                    components={{
                      DropdownIndicator: CustomDropdownIndicator,
                      IndicatorSeparator: () => null,
                    }}
                    onChange={(e: any) => {
                      setStatus(e.value);
                      setPage(1);
                      refetchDataFetch({
                        Page:1,
                        limit:itemsPerRow.name,
                        custom_id:
                          searchFilter === "custom_order_id"
                            ? searchText
                            : "",
                        collect_id:
                          searchFilter === "collect_id" ? searchText : "",
                        dispute_id:
                          searchFilter === "dispute_id" ? searchText : "",
                        start_date: isDateRangeIsSelected
                          ? formatDate(selectedRange.startDate)
                          : null,
                        end_date: isDateRangeIsSelected
                          ? formatDate(selectedRange.endDate)
                          : null,
                        status: e.value,
                        school_id: schoolId === "" ? null : schoolId,
                      });
                      
                    }}
                    placeholder={
                      <div className="text-[#1E1B59] text-xs">Status</div>
                    }
                    value={null}
                    styles={{
                      control: (provided: any) => ({
                        ...provided,
                        backgroundColor: "#F6F8FA",
                        border: "1px solid #1B163B",
                        borderRadius: "6px",

                        minHeight: "15px",
                        margin: "0px",
                        color: "#6687FF",
                      }),
                      valueContainer: (provided: any) => ({
                        ...provided,
                        padding: "0px",
                        paddingLeft: "0.5rem",
                      }),
                      input: (provided: any) => ({
                        ...provided,
                        backgroundColor: "transparent",
                        color: "#000",
                        "::placeholder": {
                          backgroundColor: "#YourDesiredColor",
                          opacity: 1,
                        },
                        placeholder: (provided: any) => ({
                          ...provided,
                          color: "red",
                        }),
                      }),
                    }}
                  />
                </div>
                {/* <div className="w-full">
                  <Institute
                    setSelectSchool={setSelectSchool}
                    setSchoolId={setSchoolId}
                    filter={filters.schoolName}
                    setFilters={setFilters}
                    refetchDataFetch={refetch}
                  />
                </div> */}
              </div>
            </div>
            <div>
              <RowsPerPageSelect
                setItemsPerRow={(e: any) => {
                  // setCurrentPage(1);
                  setItemsPerRow(e);
                  setPage(1);
                  refetchDataFetch({
                    Page:1,
                    limit:e.name,
                    custom_id:
                      searchFilter === "custom_order_id"
                        ? searchText
                        : "",
                    collect_id:
                      searchFilter === "collect_id" ? searchText : "",
                    dispute_id:
                      searchFilter === "dispute_id" ? searchText : "",
                    start_date: isDateRangeIsSelected
                      ? formatDate(selectedRange.startDate)
                      : null,
                    end_date: isDateRangeIsSelected
                      ? formatDate(selectedRange.endDate)
                      : null,
                    status: status,
                    school_id: schoolId === "" ? null : schoolId,
                  });
                }}
                itemsPerRow={itemsPerRow}
                className=" justify-start"
              />
            </div>
            <div className="flex items-center">
              {dateRange !== "" && (
                <div className=" text-sm m-2  max-w-fit ">
                  <button
                    onClick={async () => {
                      setSelectedRange({
                        startDate: startOfDay(new Date()),
                        endDate: endOfDay(new Date()),
                        key: "selection",
                      });
                      setDateRange("")
                      setPage(1);
                      setIsDateRangeIsSelected(false)
                      refetchDataFetch({
                        Page:1,
                        limit:itemsPerRow.name,
                        custom_id:
                          searchFilter === "custom_order_id"
                            ? searchText
                            : "",
                        collect_id:
                          searchFilter === "collect_id" ? searchText : "",
                        dispute_id:
                          searchFilter === "dispute_id" ? searchText : "",
                        start_date: null,
                        end_date: null,
                        status: status,
                        school_id: schoolId === "" ? null : schoolId,
                      });
                    }}
                    className="bg-[#6687FFCC] font-medium flex items-center rounded-lg text-white px-4 py-2 h-full w-full"
                  >
                    {dateRange} <HiMiniXMark className=" text-lg ml-1" />
                  </button>
                </div>
              )}
              {status !== "" && (
                <div className=" text-sm m-2  max-w-fit ">
                  <button
                    onClick={() => {
                      setPage(1);
                      setStatus("");
                      refetchDataFetch({
                        Page:1,
                        limit:itemsPerRow.name,
                        custom_id:
                          searchFilter === "custom_order_id"
                            ? searchText
                            : "",
                        collect_id:
                          searchFilter === "collect_id" ? searchText : "",
                        dispute_id:
                          searchFilter === "dispute_id" ? searchText : "",
                        start_date: isDateRangeIsSelected ? formatDate(selectedRange.startDate) : null,
                        end_date: isDateRangeIsSelected ? formatDate(selectedRange.endDate) : null,
                        status: '',
                        school_id: schoolId === "" ? null : schoolId,
                      });
                    }}
                    className="bg-[#6687FFCC] font-medium flex items-center rounded-lg text-white px-4 py-2 h-full w-full"
                  >
                    {status} <HiMiniXMark className=" text-lg ml-1" />
                  </button>
                </div>
              )}
            </div>
          </div>
        }
        data={[
          [
            "Created At",
            "Dispute ID",
            "Order ID",
            "Bank Ref.No",
            "School name",
            "Student name",
            // "Transaction ID",
            "Type",
            "Dispute Amt.",
            "Respond By",
            "Status",
            "Upload Docs",
            "View Docs",
          ],
          ...(disputeData?.getMerchantDisputes?.disputes.map(
            (item: any, index: string) => [
              new Date(item.dispute_created_date).toLocaleString("hi"),
              item.dispute_id,
              item.custom_order_id &&
              !["na", "n/a"].includes(item.custom_order_id.toLowerCase())
                ? item.custom_order_id
                : item.collect_id,
              item.bank_reference || "N/A",
              item.school_name || "N/A",
              item.student_name || "N/A",
              item.dispute_type,
              item.dispute_amount,
              new Date(item.dispute_respond_by_date).toLocaleString("hi"),
              item.dispute_status,
              item.dispute_status !== "DISPUTE_CLOSED" ? (
                <UploadDocs id={index} item={item} />
              ) : (
                "-"
              ),
              item.documents && (
                <ViewDocs
                  setUrl={setUrl}
                  setIsModalOpen={setIsModalOpen}
                  item={item}
                />
              ),
            ]
          ) || []),
        ]}
      />
    </div>
  );
}

export default Disputes;
// function usecallback(arg0: ({ start_date, end_date, status, school_id, collect_id, custom_id, dispute_id, }: {
//   start_date?: any;
//   end_date?: any;
//   status?: String;
//   school_id?: String;
//   collect_id?: String;
//   custom_id?: String;
//   dispute_id?: String;
// }) => Promise<void>, arg1: never[]) {
//   throw new Error("Function not implemented.");
// }

